import 'css-chunksrc/feature/seat-assignment/HotKeyCheckItemButtons.module.scss';export default {
  "contentGroup": "HotKeyCheckItemButtons_contentGroup",
  "contentGroupSelected": "HotKeyCheckItemButtons_contentGroupSelected",
  "contentGroupTitle": "HotKeyCheckItemButtons_contentGroupTitle",
  "contentGroupBtn": "HotKeyCheckItemButtons_contentGroupBtn"
};